import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'categoriaConcessionaria'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/concessionarias/${id}/categorias`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/categorias/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingCategoriaConcessionariaSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingCategoriaConcessionariaSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_CATEGORIA_CONCESSIONARIA_SUCCESS =
  'LOADING_CATEGORIA_CONCESSIONARIA_SUCCESS'
export function loadingCategoriaConcessionariaSuccess(categoriaConcessionaria) {
  return {
    type: LOADING_CATEGORIA_CONCESSIONARIA_SUCCESS,
    categoriaConcessionaria,
  }
}

export const DESTROYING_CATEGORIA_CONCESSIONARIA_SUCCESS =
  'DESTROYING_CATEGORIA_CONCESSIONARIA_SUCCESS'
export function destroyingCategoriaConcessionariaSuccess(categoriaConcessionariaId) {
  return {
    type: DESTROYING_CATEGORIA_CONCESSIONARIA_SUCCESS,
    categoriaConcessionariaId,
  }
}

export function fetchMultipleCategoriaConcessionaria(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchCategoriaConcessionaria(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createCategoriaConcessionaria(parentId, categoriaConcessionaria) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      categoriaConcessionaria
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateCategoriaConcessionaria(id, categoriaConcessionaria) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.UPDATE, id),
      'PUT',
      categoriaConcessionaria
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyCategoriaConcessionaria(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const categoriaConcessionaria = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_CATEGORIA_CONCESSIONARIA_SUCCESS: {
      const { categoriaConcessionaria: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_CATEGORIA_CONCESSIONARIA_SUCCESS:
      return state.delete(action.categoriaConcessionariaId.toString())

    default:
      return state
  }
}

export default categoriaConcessionaria
